export interface CategoryItem {
  name: string;
  url: string;
}

export const categories: CategoryItem[] = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { name: 'Underwear / Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];

export interface ResourceCard {
  icon: string;
  title: string;
  description: string;
  link: string;
}

export const featuredResources: ResourceCard[] = [
  {
    icon: 'ri-file-list-3-line',
    title: 'Sugargoo Spreadsheet',
    description: 'Complete product finding resources with organized categories, QC references and seller ratings all in one place.',
    link: 'https://kaspreadsheet.com',
  },
  {
    icon: 'ri-star-line',
    title: 'Sugargoo Review',
    description: 'Independent platform analysis covering features, pricing, user experience and honest pros and cons.',
    link: 'https://kaspreadsheet.com',
  },
  {
    icon: 'ri-ship-line',
    title: 'Sugargoo Shipping Cost',
    description: 'Shipping calculator guides comparing all available methods, delivery times and cost breakdowns.',
    link: 'https://kaspreadsheet.com',
  },
  {
    icon: 'ri-building-line',
    title: 'Sugargoo Warehouse',
    description: 'Complete explanation of warehouse operations, storage policies, QC process and consolidation.',
    link: 'https://kaspreadsheet.com',
  },
  {
    icon: 'ri-coupon-line',
    title: 'Sugargoo Coupon',
    description: 'Latest discount information, promotional codes and seasonal savings opportunities updated regularly.',
    link: 'https://kaspreadsheet.com',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Is Sugargoo Legit',
    description: 'Safety and trust analysis covering payment security, buyer protection and real user experiences.',
    link: 'https://kaspreadsheet.com',
  },
];

export const comparisonData = [
  { feature: 'Product Discovery', spreadsheet: 'Organized database with filters', traditional: 'Manual searching across forums' },
  { feature: 'Time Required', spreadsheet: 'Minutes to find items', traditional: 'Hours of browsing' },
  { feature: 'Product Categories', spreadsheet: '14+ organized categories', traditional: 'Limited by search queries' },
  { feature: 'Beginner Friendly', spreadsheet: 'Yes, guided navigation', traditional: 'Steep learning curve' },
  { feature: 'Shopping Research', spreadsheet: 'Simplified with QC references', traditional: 'Complex and fragmented' },
];

export const resourceComparison = [
  { resource: 'Spreadsheet', bestFor: 'Product discovery', difficulty: 'Easy', updated: 'Frequently' },
  { resource: 'Review Guide', bestFor: 'Platform research', difficulty: 'Easy', updated: 'Updated' },
  { resource: 'Shipping Guide', bestFor: 'Cost planning', difficulty: 'Medium', updated: 'Updated' },
  { resource: 'Warehouse Guide', bestFor: 'Storage knowledge', difficulty: 'Medium', updated: 'Updated' },
];

export const safetyChecks = [
  { risk: 'Fake websites', protection: 'Always verify domain authenticity before entering any personal details' },
  { risk: 'Unverified links', protection: 'Check sources and only use links from trusted independent platforms' },
  { risk: 'Expired spreadsheets', protection: 'Look for last-updated timestamps and prefer frequently maintained resources' },
  { risk: 'Payment problems', protection: 'Use trusted platforms with buyer protection and never send direct payments' },
];

export const whyUsers = [
  { icon: 'ri-search-eye-line', title: 'Faster Product Discovery', description: 'Skip endless scrolling through thousands of listings and jump straight to curated, quality-checked finds.' },
  { icon: 'ri-scales-line', title: 'Better Price Comparison', description: 'Compare prices across different sellers and platforms at a glance without opening dozens of tabs.' },
  { icon: 'ri-image-line', title: 'Understanding QC Photos', description: 'Learn how to interpret quality control images so you know exactly what you are getting before shipping.' },
  { icon: 'ri-user-star-line', title: 'Finding Reliable Sellers', description: 'Access seller ratings and community feedback to avoid scams and low-quality products.' },
  { icon: 'ri-global-line', title: 'Learning Shipping Options', description: 'Understand all available shipping methods, estimated delivery times, and cost-effective strategies.' },
];